import { SELECT_AL_SMELTER, UNSELECT_AL_SMELTER } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case SELECT_AL_SMELTER:
			return [...state, action.payload];
		case UNSELECT_AL_SMELTER: {
			return state.filter((item) => item !== action.payload);
		}
		default:
			return state;
	}
};
